import { onDocumentLoaded } from "../utils/on-document-loaded.js";
import { featuresSlider } from "../modules/home/features-slider.js";
import { mosaicSlider } from "../lib/mosaic-slider.js";

onDocumentLoaded(() => {
    console.log("[home-page.js inited]");

    featuresSlider();
    mosaicSlider();
});